import React from 'react';
import AdminContent from '../../../components/marketing/pageSections/admin/AdminContent';

function BodyAdminPage(props) {
    return (
        <>
            <AdminContent />
        </>
    );
}

export default BodyAdminPage;